<div class="pl-4 mt-4">
    <div class="row" class="pt-1">
        <h5 class="labelText"> Withdraw LCA</h5>
        <mat-divider></mat-divider>
        <form class="mt-4" #withdrawForm="ngForm">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="label-cls required">Withdraw date</label> <br />
                        <mat-form-field appearance="outline" class="date-field background_white">
                            <input [(ngModel)]="lcaWithdraw.statusUpdatedDate" name="statusUpdatedDate" matInput
                                [matDatepicker]="statusUpdatedDate" [disabled]="disableButton" placeholder="Choose a date"
                                (click)="statusUpdatedDate.open()" required>
                            <mat-datepicker-toggle matSuffix [for]="statusUpdatedDate"></mat-datepicker-toggle>
                            <mat-datepicker #statusUpdatedDate></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        
            <div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="label-cls required">Reason</label>
                        <textarea class="im-input" name="statusChangeReason" rows="4" cols="50"
                            [(ngModel)]="lcaWithdraw.statusChangeReason" [disabled]="disableButton" placeholder="Enter"
                            #statusChangeReason="ngModel" required>
                        </textarea>
                    </div>
                </div>
            </div>
        
            <mat-divider></mat-divider>
        
            <div class="row mt-4" *ngIf="showFileUpload">
                <div class="form-group col-md-12">
                    <h4>Upload Documents</h4>
                    <app-file-upload style="width: 100%;" [configurations]="configurations"></app-file-upload>
                </div>
            </div>
        
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mt-4 pl-2 text-right">
                        <button class="btn btn-outline" (click)="onDismiss()">Cancel</button>
        
                        <button (click)="saveWithdrawForm(withdrawForm)" class="btn btn-primary"
                            [disabled]="!withdrawForm.valid || disableButton">
                            Withdraw
                        </button>
                    </div>
                </div>
            </div>
        </form>
        
    </div>
</div>